/* eslint-disable react-hooks/exhaustive-deps */
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { hideChat, toogleChat, updateChat } from "../Redux/reducers/chatSlice";
import { toggleLoading } from "../Redux/reducers/loadingSlice";
import { addMessage, updateConvMessage, updateMessageFromSocket } from "../Redux/reducers/messagesSlice";
import { fetchRP } from "../Redux/reducers/recentProduct";
import { setIsSending } from "../Redux/reducers/sendingSlice";
import { changeUser } from "../Redux/reducers/userSlice";
import { toggleVerify } from "../Redux/reducers/verifySlice";
import { SELECTED_CITY, TOKEN_KEY } from "../Utils/Constants";
import { useCallbackRef } from "../Utils/useCallbackRef";
import { baseUrl } from "../shared/baseUrl";
import messageSound from "../sound/Notification.mp3";
import Categories from "./Categories/Categories";
import SingleCategory from "./Categories/SingleCategory";
import "./Chat/Chat.css";
import ChatSection from "./Chat/ChatSection";
import { cleanupSocketSubscription } from "./Chat/socketCleanupFunction/cleanupSocket";
import { createNotification } from "./Common/CreateNotification";
import Loading from "./Common/Loading/Loading";
import MenuTab from "./Common/Menu/MenuTab";
import { SocketContext } from "./Context/ContextProvider";
import Deactivate from "./Deactivate/Deactivate";
import AboutUs from "./Home/AboutUs";
import Home from "./Home/Home";
import Login from "./Navbar/Auth/Login";
import LoginAs from "./Navbar/Auth/LoginAs";
import ResetPassword from "./Navbar/Auth/ResetPassword";
import Verify from "./Navbar/Auth/Verify";
import Footer from "./Navbar/Footer/Footer";
import NavbarUI from "./Navbar/NavbarUI";
import StickyNav from "./Navbar/StickyNav";
import Products from "./Products/Products";
import SingleProduct from "./Products/SingleProduct";
import UserAllProduct from "./Products/UserAllProduct";
import RequestMyData from "./RequestMyData/RequestMyData";
import PrivacyPolicy from "./TC&Privacy/PrivacyPolicy";
import TermsAndConditions from "./TC&Privacy/TermsAndConditions";
import MyAccount from "./Users/MyAccount";

const Main = () => {
  let audio = new Audio(messageSound);
  const [isLoading, setIsLoading] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState("1");
  const location = useLocation();



  const showChat = useSelector((state) => state.showChat.showChat);

  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();

  const { customersUnreadCount, sellersUnreadCount } = useSelector((state) => state.showChat);
  const unreadMessages = customersUnreadCount + sellersUnreadCount


  useEffect(() => {
    audio.load();
    document.getElementById("clickDiv").click();
    dispatch(fetchRP({ page: 1, stateChange: true }));
    if (user !== null && !user.is_verified) {
      dispatch(toggleVerify(true));
    }
  }, [dispatch, user]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('chat') === 'true') {
      if (user) {
        if (!showChat) {
          dispatch(toogleChat());
        }
      } else {
        setLoginOpen(true);
      }
    }
  }, [location.search, user]);

  const { id: currConversationId, convContext } = useSelector((state) => state.conversationId);
  const currConvRef = useCallbackRef(currConversationId);
  const currConvContextRef = useCallbackRef(convContext)
  const showChatRef = useCallbackRef(showChat);

  const playSound = (socketMessage, audio, messCond) => {
    if (
      document.hasFocus() === false ||
      currConvRef.current === 0 ||
      !messCond ||
      !showChatRef.current
    ) {
      audio.play();
    }
    const title = document.title;
    document.title = `${socketMessage.message}: (${socketMessage.seller.id === user.id
      ? socketMessage.customer.name
      : socketMessage.seller.name
      })`;
    setTimeout(() => {
      document.title = title;
    }, [5000]);
  };

  const socket = useContext(SocketContext)

  const updateMessage = (socketMessage, isReceived) => {
    const updatedMessage = {
      message: socketMessage.message,
      sellerId: socketMessage.seller.id,
      customerId: socketMessage.customer.id,
      isReceived: isReceived,
      conversationId: currConvRef.current,
      conversationContext: currConvContextRef.current
    };

    if (socketMessage.seller.id === user.id) {
      dispatch(
        updateChat({
          ...updatedMessage,
          updateRequestedOn: "customers",
        })
      );
    } else if (socketMessage.seller.id !== user.id) {
      dispatch(
        updateChat({
          ...updatedMessage,
          updateRequestedOn: "sellers",
        })
      );
    }
  }

  useEffect(() => {
    if (user) {
      if (socket) {
        socket.on("connection", () => {
          console.log("user connected");
        });

        cleanupSocketSubscription({ socket: socket, event: "message" });

        socket.on("sent", (socketMessage) => {
          dispatch(setIsSending(false));
          const messCond = (currConvContextRef.current === 'customers' && currConvRef.current === socketMessage?.customer?.id) || (currConvContextRef.current === 'sellers' && currConvRef.current === socketMessage?.seller?.id)

          if (messCond) {
            dispatch(updateConvMessage(socketMessage))
          }
          dispatch(updateMessageFromSocket({ message: socketMessage, userId: user.id }))
          updateMessage(socketMessage, false)
        })

        socket.on("message", (socketMessage) => {

          const messCond = (currConvContextRef.current === 'customers' && currConvRef.current === socketMessage?.customer?.id) || (currConvContextRef.current === 'sellers' && currConvRef.current === socketMessage?.seller?.id)

          playSound(socketMessage, audio, messCond);
          if (messCond) {
            dispatch(addMessage(socketMessage));
          }
          dispatch(updateMessageFromSocket({ message: socketMessage, userId: user.id }))
          updateMessage(socketMessage, true)
        });
      }
    }

    return () => {
      if (user && socket) {
        socket.on("disconnect");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, user,]);

  // getting messages from the socket .................
  // useEffect(() => {

  // }, [socket, currConversationId, user.id, dispatch]);

  useEffect(() => {
    if (showChat) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showChat]);

  function PageNotFound() {
    return (
      <>
        <div
          style={{ height: "90vh", overflow: "hidden" }}
          className="d-flex flex-wrap w-100 justify-content-center align-items-center"
        >
          <div className="text-center small">
            <img
              alt="logo"
              style={{ objectFit: "contain", height: "20vh", width: "20vh" }}
              src="/assets/images/logo.png"
            />
            <p className="rotate" style={{ fontSize: "800%" }}>
              4O4
            </p>
            <h3>Page Not Found</h3>
            <p className="small">
              Go to <Link to="/">home</Link>
            </p>
          </div>
        </div>
      </>
    );
  }

  const logout = async () => {
    dispatch(toggleLoading(true));
    if (showChat) {
      dispatch(toogleChat())
    }
    fetch(baseUrl + "logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          localStorage.removeItem(TOKEN_KEY);
          localStorage.removeItem(SELECTED_CITY);
          dispatch(changeUser(null));
          createNotification("success", "Successfully logged out");
          dispatch(toggleLoading(false));
        } else {
          createNotification("error", "Logout Unsuccessful");
          localStorage.removeItem(TOKEN_KEY);
          localStorage.removeItem(SELECTED_CITY);
          dispatch(changeUser(null));
          dispatch(toggleLoading(false));
        }
      })
      .catch((err) => {
        dispatch(toggleLoading(false));
        createNotification("error", "Error logging out");
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(SELECTED_CITY);
        dispatch(changeUser(null));
      });
    document.body.style.overflow = "auto";
  };

  return (
    <>
      <GoogleOAuthProvider clientId="86348526108-gfkloscuhsnhq79957hc56gb7k0vtnrb.apps.googleusercontent.com">
        <NavbarUI
          loginOpen={loginOpen}
          setLoginOpen={(val) => {
            setLoginOpen(val);
          }}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          logout={logout}
        />
        {/* <ScrollToTop /> */}
        <div className="switch-body">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:pid/:pname" element={<SingleProduct />} />
            <Route path="/products/:pid" element={<SingleProduct />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/categories/:subcategoryId/:subcategoryName" element={<SingleCategory />} />
            <Route path="/users/myaccount" element={<MyAccount />} />
            <Route path="/products/userallproducts/:sname/:sid" element={<UserAllProduct />} />
            <Route
              path="/password-reset/:email/:token"
              element={<ResetPassword />}
            />
            <Route path="/login-as/:token" element={<LoginAs />} />
            <Route path="*" element={<PageNotFound />} />
            <Route exact path="/users/account-deactivate" element={<Deactivate />} />
            <Route exact path="/users/request-my-data" element={<RequestMyData />} />
            <Route exact path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route exact path="/about-us" element={<AboutUs />} />


          </Routes>
        </div>
        <Footer
          user={user}
          setLoginOpen={(val, index = "1") => {
            setLoginOpen(val);
            setActiveIndex(index);
          }}
        />

        <StickyNav
          setLoginOpen={() => {
            setLoginOpen(true);
          }}
          logout={logout}
          showChat={showChat}
          badge={unreadMessages}
        />

        <MenuTab
          onClick={() => {
            dispatch(hideChat());
          }}
          animDelay={0}
          link={"/"}
          top={100}
          hoverWidth={100}
          image={"svg/home.svg"}
          title="Home"
        />
        <MenuTab
          onClick={() => {
            dispatch(hideChat());
          }}
          animDelay={0.5}
          link={"/categories"}
          top={160}
          hoverWidth={140}
          image={"svg/dash.svg"}
          title="Categories"
        />
        {/* <MenuTab
          onClick={() => {
            dispatch(hideChat());
          }}
          animDelay={1}
          link={"/products"}
          top={220}
          hoverWidth={130}
          image={"svg/product.svg"}
          title="Products"
        /> */}
        {user && (
          <>
            <MenuTab
              onClick={() => {
                dispatch(toogleChat());
              }}
              animDelay={1}
              top={280}
              showChat={showChat}
              hoverWidth={90}
              image={"svg/chat.svg"}
              title="Chat"
              badge={unreadMessages}
            />
          </>
        )}

        {user ? (
          <MenuTab
            animDelay={1.5}
            logout={logout}
            isMenu={true}
            link={"/users/myaccount/"}
            top={220}
            hoverWidth={100}
            image={"svg/user.svg"}
            title="Users"
            onClick={() => {
              dispatch(hideChat());
            }}
          />
        ) : (
          <MenuTab
            animDelay={1.5}
            isMenu={true}
            setLoginOpen={(val, index = "1") => {
              setLoginOpen(val);
              setActiveIndex(index);
            }}
            isLogin={true}
            top={220}
            hoverWidth={100}
            image={"svg/login.svg"}
            title="Login"
          />
        )}

        <Login
          isLoading={isLoading}
          setIsLoading={(val) => {
            setIsLoading(val);
          }}
          isOpen={loginOpen}
          activeIndex={activeIndex}
          onClose={() => {
            setLoginOpen(false);
          }}
        />
        <div className={`${showChat ? "chat-popup" : "hide-chat"} `}>
          <ChatSection />
        </div>
        <Verify />
        <Loading />
        <div id="clickDiv"></div>
      </GoogleOAuthProvider >
    </>
  );
};

export default Main;
